<template>
  <div class="search-wrap" style="display: block;">
    <div class="search-input-box">
      <form>
        <button class="input-sm-search js-search" @click="goSearch">
          <i class="icon icon-sm-search"></i>
        </button>
        <input type="search" id="top-search" class="search-input" placeholder="委托单号、报告编号或其他关键词" v-model="keyword" @input="searchWatch" :clearable="false"/>
        <a class="close-box js-search-cancel" @click="searchToggle(false)">取消</a>
      </form>
    </div>
    <div v-show="!searchList.length">
    <div class="search-act search-history-act">搜索热点</div>
    <ul class="search-ul search-history">
      <li>
        <a href="/mat_l">材料</a>
      </li>
      <li>
        <a href="/standard_l">标准</a>
      </li>
      <li>
        <a href="/ra_l">失效案例</a>
      </li>
    </ul>
    </div>
    <div class="bg-box" v-show="searchList.length">
    <div class="inner-box">
      <div v-for="(ele,index) in searchList" :key="index+'sr'" class="sr-box" @click="goRes(ele)">
        <a class="tag-p">{{searchResType}}</a>
        <a :href="ele.url" class="tag-content">{{ele.display_no}}</a>
      </div>
    </div>
    </div>
    <!--
            <div class="search-act search-hot">
            热搜词
        </div>
        <ul class="search-ul search-hot">
                    <li><a href="/standard">标准查询</a></li>
                </ul>
    -->
  </div>
</template>

<script>
export default {
  name: "searchBar",
  components: {},
  data() {
    return {
      loginInfo: {
        account: "",
        password: ""
      },
      keyword:"",
      searchList:[
        
      ],
      searchResType:''
    };
  },
  props: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
    searchToggle(value) {
      this.$emit("searchToggle", value);
    },
    goSearch() {
      if(/^\d{7}$/.test(this.keyword)){
        this.$router.push({path:'/c_i/'+this.keyword});
      }

    },
    searchWatch(){
      this.searchList = [];
      if(/^(T\d{2}(\d{4,10}|\d[CHNASRCC]{3}|\d{1,2}[CHNASRCC]{1,2}\d)\d{3})|(T\d{7})|\d{6,9}$/.test(this.keyword)){
        this.searchResType = "委托单";
          this.$axios
        .post(this.$url + "/ask_contract_info", {
              userToken: localStorage.getItem("current_user_token"),
              askData: 'checkProjectDisplayNo',
              project_display_no:this.keyword,
            })
            .then(response => {
              if (response.data.do_stat == "ok") {
                this.searchList.push({url:'/contract_stat/'+response.data.display_no,display_no:this.keyword});
              } else if(response.data.do_stat == 'nothing'){
                this.searchList.push({url:undefined,display_no:'未找到单号为'+this.keyword+'的记录'});
              }
            });
      }else if(/^([A-Z]20\d{6})|(TP\d{2,3}[TJLHZ]\d+[SRCCFFH]{0,3}\d{3})$/.test(this.keyword)){
        this.searchResType = "报告";
        this.$axios
        .post(this.$url + "/ask_report_info", {
              userToken: localStorage.getItem("current_user_token"),
              askData: 'checkReportDisplayNo',
              report_display_no:this.keyword,
            })
            .then(response => {
              if (response.data.do_stat == "ok") {
                
                this.searchList.push({url:'/wreportQuery/'+this.keyword,display_no:this.keyword});
              } else if(response.data.do_stat == 'nothing'){
                this.searchList.push({url:undefined,display_no:'未找到编号为'+this.keyword+'的报告'});
              }
            });
      }
    },
    goRes(val){
      location.href = val.url;

    }
  }
};
</script>

<style scoped>
.search-wrap,
.search-wrap-show {
  position: fixed;
  background: #fff;
  top: 0;
  left: 0;
  right: 0;
  padding-bottom: 50px;
  display: none;
  height: 100%;
  z-index: 1100;
  max-width: 640px;
  margin: 0 auto;
}

.search-input-box {
  padding: 0 15px;
  height: 50px;
  line-height: 44px;
  border-bottom: 1px solid #f0f0f0;
}

.search-wrap .input-sm-search {
  right: 50px;
}

.input-sm-search {
  position: absolute;
  right: 20px;
  top: 0;
  border: none;
  background: 0 0;
}

button,
html input,
textarea {
  cursor: pointer;
  outline: 0;
}

.icon {
  display: inline-block;
  vertical-align: text-bottom;
  background: url(../assets/icon.png) no-repeat;
  width: 15px;
  height: 16px;
  cursor: pointer;
  background-size: 250px 300px;
}

.icon-sm-search {
  background-position: -184px -102px;
  width: 43px;
  height: 33px;
  margin-top: 6px;
}

.search-wrap .search-input,
.search-wrap-show .search-input {
  width: 100%;
  height: 33px;
  border-radius: 33px;
  background: #f5f5f5;
  border: none;
  color: #333;
  font-size: 14px;
  padding: 5px 15px;
  margin-top: 9px;
}

.search-wrap .search-input {
  width: 88%;
}

.search-wrap .close-box {
  position: absolute;
  right: 5px;
  font-size: 16px;
  color: #bbb;
  display: inline-block;
  padding: 0 10px;
  line-height: 50px;
}

a {
  color: #303030;
  cursor: pointer;
  text-decoration: none;
}

.search-act {
  margin: 25px 15px 0 15px;
  font-size: 14px;
  color: #bbb;
  height: 23px;
  line-height: 23px;
  border-bottom: 1px solid #f0f0f0;
  display: inline-block;
  width: 100%;
}

.search-ul {
  margin: 0 15px;
  background: #fff;
}

ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 10px;
  padding-inline-start: 10px;
}

.search-ul li {
  height: 30px;
  border-radius: 30px;
  border: 1px solid #f0f0f0;
  margin: 15px 15px 0 0;
  float: left;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
  padding: 0 10px;
}

ol li,
ul li {
  list-style: none;
}

a {
  color: #303030;
  cursor: pointer;
  text-decoration: none;
}

.search-ul {
  margin: 0 15px;
}

.search-ul li {
  height: 30px;
  border-radius: 30px;
  border: 1px solid #f0f0f0;
  margin: 15px 15px 0 0;
  float: left;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
  padding: 0 10px;
}

.search-hot a {
  color: #f97752;
}

.inner-box{
  background: #fff;
}

.sr-box{
  height:3rem;
  line-height: 3rem;
  border-bottom:1px solid #eee;
  margin:0 1rem;
  position: relative;
}

.tag-p{
  position: relative;
  font-size:0.5rem;
  padding: 0.2rem 0.4rem;
  background: #eee;
  bottom:0.3rem;
  margin-right:0.5rem;
}

.bg-box{
  background: #eee;
  height:100%; 
}
.tag-content{
  font-size: 0.8rem;
}
</style>